import Vue from 'vue'
import { CategoryService} from '@/common/api.service'
import { SortUtils } from '@/common/utils.js'

import {
    FETCH_CATEGORY,
    FETCH_CATEGORIES,
    CATEGORY_RESET_STATE,
    CATEGORY_SET_DEFAULT,
} from './actions.type'

import {
    SET_CATEGORIES,
    SET_CATEGORY,
    RESET_STATE,
} from './mutations.type'

const defaultCategory = {
    get() {
        return {
            name:''
        }
    }
}

const initialState = {
    category: defaultCategory.get(),
    categories: []
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_CATEGORY] (context, id) {
        let entity = state.categories.find(c => c.id == id);
        if (entity !== undefined) {
            return context.commit(SET_CATEGORY, entity)
        }

        return CategoryService.get(id)
        .then(({ data }) => {
            context.commit(SET_CATEGORY, data)
            return data
        })
    },
    [CATEGORY_SET_DEFAULT] (context) {
        return context.commit(SET_CATEGORY, defaultCategory.get())
    },
    [FETCH_CATEGORIES] (context) {
        return CategoryService.get()
        .then(({ data }) => {
            let sortedData = SortUtils.sortAsc(data, {prop: 'name'})
            context.commit(SET_CATEGORIES, sortedData)
        })
    },
    [CATEGORY_RESET_STATE] ({ commit }) {
        commit(RESET_STATE)
    }
}

export const mutations = {
    [SET_CATEGORIES] (state, categories) {
        state.categories = categories
    },
    [SET_CATEGORY] (state, category) {
        state.category = category
    },
    [RESET_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    categories (state) {
      return state.categories
    },
    category (state) {
        return state.category
    }
  }

export default {
    state,
    actions,
    mutations,
    getters
}